import Annie from '../static/images/sectionTalking/2020/Annie.jpg';
import Erica from '../static/images/sectionTalking/2020/Erica.jpg';
import Joanna from '../static/images/sectionTalking/2020/Joanna.jpg';
import Luffy from '../static/images/sectionTalking/2020/Luffy.jpg';
import Miao from '../static/images/sectionTalking/2020/Miao.jpg';
import Paul from '../static/images/sectionTalking/2020/Paul.jpg';
import PK from '../static/images/sectionTalking/2020/PK.jpg';
import Raymond from '../static/images/sectionTalking/2020/Raymond.jpg';
import Sherry from '../static/images/sectionTalking/2020/Sherry.jpg';
import TingYu from '../static/images/sectionTalking/2020/Ting-Yu.jpg';
import Welsen from '../static/images/sectionTalking/2020/Welsen.jpg';
import YiShan from '../static/images/sectionTalking/2020/YiShan.jpg';


import AnniePhoto from '../static/images/sectionTalking/2020/AnniePhoto.png';
import EricaPhoto from '../static/images/sectionTalking/2020/EricaPhoto.png';
import JoannaPhoto from '../static/images/sectionTalking/2020/JoannaPhoto.png';
import LuffyPhoto from '../static/images/sectionTalking/2020/LuffyPhoto.png';
import MiaoPhoto from '../static/images/sectionTalking/2020/MiaoPhoto.png';
import PaulPhoto from '../static/images/sectionTalking/2020/PaulPhoto.png';
import PKPhoto from '../static/images/sectionTalking/2020/PKPhoto.png';
import RaymondPhoto from '../static/images/sectionTalking/2020/RaymondPhoto.png';
import SherryPhoto from '../static/images/sectionTalking/2020/SherryPhoto.png';
import TingYuPhoto from '../static/images/sectionTalking/2020/Ting-YuPhoto.png';
import WelsenPhoto from '../static/images/sectionTalking/2020/WelsenPhoto.png';
import YiShanPhoto from '../static/images/sectionTalking/2020/YiShanPhoto.png';

export default [
    {
        name: "LUFFY",
        position: "Front-End Developer",
        img: LuffyPhoto,
        photo: Luffy,
        article: `
            <p>你好，我是從來沒看過航海王的 Luffy 。</p>

            <p>對出身社會科學背景的我來說，加入新芽別具意義。</p>

            <p>一年前的今天，我只懂得怎麼運用 JavaScript Fetch 串 API ，來到新芽實習後，在一次次參與實戰開發的過程中，逐漸掌握 React 語法，撰寫較為複雜的邏輯。在 Mentor 悉心指導下，我漸漸瞭解如何撰寫簡潔、易讀又利於維護的程式碼。後來，有機會參與大型專案開發，為了確保網站穩定運作，硬著頭皮栽進 TypeScript 大坑。一連串的實戰經驗，不斷擴充我的前端技能樹，確實鍛鍊了開發能力，這大概是我一年前無法料想到的成長。</p>

            <p>除了技術以外，在新芽實習，可以見證一項專案從無到有的歷程，學習如何和 PM 、 UI 以及後端溝通，說明開發的可行性與難為之處，訓練自己的表達技巧，並控管工作進度，對自己的任務負責。遇到困難，如果真的沒辦法解決，也無須擔心，新芽的夥伴們各個臥虎藏龍，只要提出來討論，事情往往會迎刃而解。</p>

            <p>總而言之，這裡提供一個對新手相當友善的環境，而且零食區有豐富的餅乾和飲料，吃太多也不怕胖，加入公司的籃球社、羽球社，或自己去外面健身房運動，都能申請津貼。工作時，大家也不是一直悶著，輪流當 DJ 點播音樂，開團訂購點心和手搖杯，追時下最夯的天竺鼠車車，還有偶爾彼此聊天傳來的笑聲，都讓我覺得，在這裡工作真的好快樂！</p>

            <p>這種兼顧生活和成長的實習哪裡找呢？不要猶豫，投出你的履歷吧！</p>
        `,
    },
    {
        name: "YISHAN",
        position: "Front-End Developer",
        img: YiShanPhoto,
        photo: YiShan,
        article: `
            <p>Hi, 我是 Front-End intern 13</p>

            <p>
                先講重點：</br>
                <span>（一）新芽是個很適合兼顧課業、接軌業界的地方</span></br>
                <span>（二）可以跟厲害的大神們面對面合作，一起討論前端技術</span></br>
                <span>（三）不需要特別厲害，但一定要對寫前端很有熱情，並能持續學習</span>
            </p>

            <p>如果你／妳想增加實戰經驗，新芽真的是一個很棒的選擇！</p>

            <p>雖然在新芽快一年了，但偶爾還是會覺得像是一場幸福的美夢。</p>

            <p>當初在找實習時，常擔心自己不夠好，Github 上沒有幾百顆星的專案，也不是相關科系，只單純抱持著「我好喜歡寫程式，我想要找一個可以讓我專心鑽研前端技術的地方」的想法，然後在朋友推薦下發現「新芽看起來不錯耶！而且招募網站好漂亮」，回過神來我已經送出履歷了，最後幸運的以「前端實習生」的身份，度過在大學的最後一年。</p>

            <p>在新芽的實習生活真的很充實，在這裡主要會碰到 React/TypeScript，偶爾會幫忙維護 Pug/Vue ，也有機會碰到 Angular，對於以前完全不會框架的我來說都是新的挑戰，但是每週完成工作任務後，都會有餘裕可以學習新技術，特別是 Mentor 們會指導如何優化效能，並練習寫出別人也能輕易讀懂的程式碼，在合作的過程中，也能透過觀摩正職們的程式碼來檢視自己的不足。</p>

            <p>在工作之餘，公司還有免費午餐跟一堆零食飲料，對於北漂學子來說真的是一大福音，如果怕太胖被吃掉的話也有健身補助可以消弭罪惡感。</p>

            <p>最後，如果你／妳想增加實戰經驗，新芽真的是一個很棒的選擇！</p>
        `,
    },
    {
        name: "RAYMOND",
        position: "Back-End Developer",
        img: RaymondPhoto,
        photo: Raymond,
        article: `
            <p>新芽是個不可思議的地方。</p>

            <p>還記得去年四月剛從一間新創公司離職的我，抱著一顆忐忑的心四處投遞履歷，一直很擔心從此會步上每日朝九晚五、工作內容乏味的生活，沒想到不僅幸運的拿到新芽的 offer，on board 之後的日子更是顛覆了我對一間公司的想像。</p>

            <p>新芽是個重視溝通的地方，在陸續協助的幾個專案中，我學習到了如何與團隊成員有效率的合作；新芽是個彈性交流的地方，除了負責後端工程外，devops 的大大們也滿足了我對雲端知識的渴望；新芽是個不乏挑戰的地方，雲端服務的串接和高流量的情境都是以往的我未曾面對過的；更重要的是，新芽是個充滿歡笑的地方，即使大家經常忙於自己的專業，還是會抽空關心彼此、講講垃圾話，讓整間辦公室都充滿生氣。</p>

            <p>如果你是一個衷於有趣工作的人，新芽的人事物絕對不會讓你失望，快來成為我們的一員吧！</p>
        `,
    },
    {
        name: "SHERRY",
        position: "iOS Developer",
        img: SherryPhoto,
        photo: Sherry,
        article: `
            <p>慶幸自己有把握這個機會，讓我在因為疫情交換被取消的日子，體驗另一種和校園完全不同的充實生活！</p>

            <p>我覺得在這裡最棒的是大家不分專業、部門都會一起討論和分享，不管是專案的執行、專業的知識或是生活上的小故事跟笑話。遇到問題的時候也總能受到來自 Mentor 或其他領域大大的協助，學到很多額外的東西！</p>

            <p>新芽的實習生很幸福，也可以享受很多公司福利，比如取之不盡的零食飲料，時不時就會有偉大的人訂飲料，有愛的同事請鹹酥雞、雞排和一些下班後開心的活動！</p>

            <p>感謝 Mentor 老大很信任我，把 issue 交給我做，讓我一起參與專案的開發。老大每週都會抽空幫我 brief 進度和 code review（讓我不敢隨便亂寫哈哈～），回答我很多問題，也分享很多實務上的經驗。每個禮拜都覺得自己又進步了一些！</p>

            <p>我在這裡得到很多成就感和快樂，現在想想當時的我真是太幸運了可以進到新芽實習，這就是幸福企業吧 🥺</p>
        `,
    },
    {
        name: "WELSEN",
        position: "Android Developer",
        img: WelsenPhoto,
        photo: Welsen,
        article: `
            <p>Hello, 我是新芽 Android Development Intern 的實習生 Welsen </p>
            
            <p>暑假期間，在 Medium 上面看到其他人在新芽工作時的心得文章，想著如果我也能進去這麼酷的網路公司，那該有多好。</p>

            <p>我從沒想過有一天我真的收到了這間公司的 offer，那天回想起來，我還是感覺非常不真實且興奮。畢竟，這算是我第一份工作。</p>

            <p>剛進新芽實習時，我很幸運的有一個很照顧我的 Mentor，我非常感謝他。他指導了我許多在 Android 開發上的技術，也常常做 Code Review 給了我許多回饋，這讓我感覺到，寫出可以用的 Code 跟寫出一個好的 Code 是一件很不一樣的事。在這期間，他同時也實際讓我參與到專案的開發，除了增進本身的技術力以外，能在客戶的專案上看到自己留下的紀錄，真的會產生很大的成就感 。從一個不懂的菜鳥到能慢慢開始獨立完成客戶的需求，這在你寫 Code 的時候，你會感覺很過癮。</p>

            <p>在新芽還有一點很棒的是，公司內部有非常多來自不同學校、科系的實習生，你可以跟不同的夥伴討論著不同的話題，交換不同的資訊。而公司也會定期舉辦 Workshop 讓你學習新的東西，或讓你分享你所學到的東西。最後，我覺的公司提供給實習生的福利也蠻棒的，至於是什麼我相信其它人也已經寫完了吧 XD。</p>

            <p>除了福利以外，工作之餘也能參加許多公司內部的社團，運動或打遊戲的都有。在這裡，你絕對能找到一個屬於你舒適的地方待著。簡單來說，是一間工作環境跟福利都很酷的公司。</p>

            <p>如果你還在猶豫，不用猶豫了，趕快來投遞一份你喜歡的職缺，並加入進來吧！！！</p>
        `,
    },
    {
        name: "ANNIE",
        position: "Project Management",
        img: AnniePhoto,
        photo: Annie,
        article: `
            <p>Hi 我是 PM intern Annie</p>

            <p>因交換計劃延期而成為新芽一份子的我，回想起整段實習旅程只能說是又幸運又感謝。</p>

            <p>擔任專案管理實習生的日子裡，不管是從中段加入，或是從最零開始規劃的案子，我非常幸運的接觸到大大小小不同的專案類型。</br>從專案的 kick off、與客戶討論需求、UI 的規劃、技術層面的 API 串接，甚至到後期專案的 bug 修復與測試，透過這些實戰經驗，讓非本相關科系出身的我，快速累積知識與經驗，對我來說非常難能可貴！</p>

            <p>除了專案管理或其他資訊技術知識外，新芽的工作環境十分舒適彈性，氣氛自由讓人在工作時不緊繃，最重要的是公司同事之間的相處從不讓人感到有壓力，不只樂於共享工作知識，更能彼此交流興趣，就像是和一群很棒的朋友們共事！</p>

            <p>最後我想說的是，因為疫情取消的交換計畫讓我很幸運地來到了新芽，經歷了一年美好又值得的實習旅程！如果你對專案管理或網路科技產業非常有興趣，快來加入成為新芽的一份子，親自打造自己最棒的實習體驗！</p>
        `,
    },
    {
        name: "PAUL",
        position: "Project Management",
        img: PaulPhoto,
        photo: Paul,
        article: `
            <p>Hi, 我是新芽的 PM 實習生 Paul</p>

            <p>時間不知不覺過了快一年，真的很慶幸能加入新芽這個大家庭。在這段實習時光中，自己真的是在各方面都成長很多，從對專案管理只有初淺的了解，一直到了解專案流程，並協助專案經理執行厲害又有趣的專案。在這過程中，學習獨當一面的專案經理所具備的能力，面對各種可能發生的挑戰，並將自己所學應用在專案之中。</p>

            <p>以公司的文化氛圍來說，新芽真的是超酷的網路公司，非常的自由開放，還有非常多有趣的社團和活動可以參加，像是包場的電影之夜、全公司一起出遊的 Outing、送好禮的尾牙聚餐。上述的活動實習生都能一起參加，真的能感受到公司對實習生的用心。</p>

            <p>新芽的同事們形形色色，不論是正職還是實習生，都有著各自的專長，共通點就是他們都很樂於交流和分享，與其說是同事很多人其實更像是朋友，有時大家上完班還會一起玩桌遊、看電影、唱歌，真的很快樂哈哈。</p>
        `,
    },
    {
        name: "ERICA",
        position: "Account Management",
        img: EricaPhoto,
        photo: Erica,
        article: `
            <p>Hi 我是 AM 實習生 Erica～</p>
            
            <p>我想說能在去年暑假進到新芽擔任 AM 實習生真的是很棒的一件事！</p>

            <p>在新芽實習，真的感受到很自由、開放的新創公司風氣，有種大家一起前進努力的感覺。與其說擔任實習生，有時候會覺得和 mentor 的關係更像夥伴，非常願意放手讓我接觸 AM 工作的各個面向，讓我對這份職位有更深的認識。</p>

            <p>擔任 AM 實習生期間，常常有機會和 mentor 一起去業務拜訪，親自站在第一線接觸各行各業的客戶，了解他們的需求。主管會願意讓我著手規劃提案、一起腦力激盪發想如何替客戶解決問題。（經手的提案如果成案了都會很開心XD）遇到任何問題時，mentor 和公司的同事們也都很樂意替你解答問題，讓你不斷的進步跟成長！</p>

            <p>除此之外，每個月的內部 Workshop、每天都有免費午餐、還有健身房補助、電影之夜等等小福利，更是在新芽實習的一大福音！每天上班都很快樂！</p>

            <p>如果你也想親自感受這麼棒的實習氛圍的話，快投履歷加入我們吧！</p>
        `,
    },
    {
        name: "JOANNA",
        position: "SurveyCake Marketing",
        img: JoannaPhoto,
        photo: Joanna,
        article: `
            <p>嗨～我是第七屆的馬克庭實習生 Joanna (´▽｀)</p>

            <p>在新芽的日子裡，真的每一天都非常充實，有學不完的經驗、吃不完的零食、聽不完的音樂，還有做不完的…（威～）</p>

            <p>其實新芽是我人生中的第一份實習，真的很幸運第一份實習是在新芽。在新芽的這幾個月裡，不但可以實際動手當一個真正的行銷人外，還可以遇到非常多厲害、有趣、人又 super nice 的 mentor、同事與朋朋！我就不多說有多少朋友羨慕我每天開心幸福的跟什麼一樣。(⁎⁍̴̛ᴗ⁍̴̛⁎)</p>

            <p>而作為新芽的行銷實習生，你會有很多機會接觸行銷的大小事，包括當部落格寫手、經營蛋糕粉專、分析與抓會員數據、處理異業合作、每月提案、參加展覽、練習優化會員使用流程等等，Mentor 也會給你很大的發揮空間，並且手把手教學，告訴你哪裡需要考慮清楚、哪裡需要加強、哪裡可以更好，因此在新芽這幾個月，我的成長幅度飆高，to infinity and beyond 之類的。除了數位行銷外，科技或網路相關的用語你也能略知一二，比如 GTM、API、SQL 等等…，當然，你甚至可以一窺科技產業在推出新功能或全新面貌時，會經歷的過程與跨部門的合作。</p>

            <p>如果說，對於新創公司、科技網路有興趣的話，你絕對不能錯過新芽，不然一定會後悔很久很久。</p>

            <p>Hey，不要讓自己錯過一次幸福的機會，決定好了就投出你的履歷吧！</p>
        `,
    },
    {
        name: "PK HUNG",
        position: "Product Management",
        img: PKPhoto,
        photo: PK,
        article: `
            <p>Hi ! 我是新芽的 SurveyCake PM Intern 鵬凱</p>

            <p>回想起來，還是相當慶幸自己能進到新芽。</p>

            <p>新芽的同事們及 mentor 相處起來就像學長姐，沒有包袱樂於交流、分享經驗，而大家更具備各式各樣的專業與技能，時常讓我大開眼界。此外，新芽提供很好的環境、氛圍與彈性。除了可以吃到好吃的午餐跟點心，空間規劃上也別有巧思。今天如果想感受活力跟其他人交流，你可以到人多的座位區甚至正職的座位旁一起工作；如果想一個人靜一靜，也隨時可以到個人或角落的座位空間，讓你專心地工作與沉澱。</p>

            <p>工作上，兼顧適當負荷及挑戰性的任務，總是能獲得收穫與成就感。實習的過程可以了解完整產品的運作與細節，嘗試到產品的競品分析、功能測試，接觸產品優化、wireframe 製作及新功能規劃，參與產品開發及市場會議等多元的工作。而其中最讓我深刻學習的，是與各式各樣的跨部門溝通合作，並且將複雜資訊去蕪存菁，開展策略與設計。</p>

            <p>在這裡，既能體驗多部門專業分工的組織運作，也可以感受快速成長中的年輕新創活力。如果你對產品管理、網路產業、甚至是一個有良好組織文化的新創有興趣，都推薦加入成為新芽的一份子 !</p>
        `,
    },
    {
        name: "TING-YU",
        position: "UI/UX Designer",
        img: TingYuPhoto,
        photo: TingYu,
        article: `
            <p>從兩年前開始就有在關注新芽的實習職缺，但一直覺得自己累積的作品還不夠完整，遲遲不敢投下履歷，今年終於拿出勇氣、踏出舒適圈，最後很幸運地來到新芽，並成為大家的夥伴。</p>

            <p>我在新芽主要負責的工作是支援專案的設計，和以往自主練習的作品不同，我才了解到原來一個專案會有非常多細節要注意，像是除了客戶目標外，還要考量到使用者需求以及開發技術的限制，要如何在這三者之間取得平衡，中間會經過多次的修改，難免會遇到一些問題，但不管是 mentor 們還是其他夥伴，都會耐心的幫忙解答，讓我在每個任務中，總能帶著意想不到的收穫，滿載而歸。</p>

            <p>工作之餘的福利就如職缺上所寫的那樣，對實習生也豪不吝嗇，彈性的上班時間、免費的午餐、跟沙威瑪一樣會自己長出來的零食，除此之外，同事間溫韾的垃圾話絕對是我上班的動力之一，如果你也想體驗這種歡樂的上班氛圍，並且累積職場上的實戰經驗，新芽會是一個很讚的選擇！</p>
        `,
    },
    {
        name: "MIAO",
        position: "Administrator",
        img: MiaoPhoto,
        photo: Miao,
        article: `
            <p>嗨大家，我是 Miao</p>

            <p>進到新芽半年多了，依舊覺得能夠進入新芽是件很幸運及幸福的事！我的工作內容主要是處理午餐訂單以及舉辦一些軟性活動，訂購零食（把大家餵的飽飽的！），處理顧客的電話詢問或是一些突發事項，讓大家可以在一個舒適良好的環境下工作～</p>

            <p>回想被通知到現場面試時，第一眼看到辦公室覺得「哇，辦公室也太漂亮了吧！」跟大部分的辦公室很不一樣，有許多自由辦公的區域，大家可以選擇自己今天想在坐在哪裡上班，我想這就是新創的魅力吧！不死板的侷限著大家，快樂的工作環境既可以提升工作效率，也能創造出更多想法。</p>

            <p>在新芽的這段期間內學習到最多的是，如何有效的完成主管交代事項以及例行公事。行政的工作不難但很繁瑣，所以需要學習如何分配好自己的時間，並且不遺漏待辦事項！幸運的是，主管很願意的教導我們，在一開始什麼都不懂甚至很混亂的時候，一個星期的一次會議，了解我的困擾並且給予我解決的方法！也很相信我們，給我們機會去學習如何舉辦一個活動、與廠商聯繫學習說話技巧。不侷限我們的想法，但在遇到困難時絕對是第一個幫助我們的。讓我在每一次的學習下，成為更好的自己！</p>

            <p>喜歡新芽的朋朋們，別猶豫了！新芽不會讓你失望的！</p>
        `,
    },
];



// WEBPACK FOOTER //
// ./src/models/Sprouters2020.js